<ng-content select="slnk-shared-checkbox-validator-item">
</ng-content>
